<template>
  <div class="wrap">
    <div class="litops orangeToYellow">
      <div class="litop1">
        <div class="litop1_left ellipsis">
          <div class="deviceName ellipsis">{{ deviceInfo.deviceName }}</div>
          <span
            v-show="deviceInfo.type !== 2"
            :class="online ? 'online' : 'offline'"
          >
            {{ online ? $t('live.online') : $t('live.offline') }}
          </span>
        </div>
      </div>
      <div class="litop2 fs24">
        <!-- 轮灌组入口 -->
        <span
          class="lunguan"
          v-if="deviceInfo.type === 4 || deviceInfo.type === 6"
          @click="handleLunguan"
        >
          <span>
            <img src="./../../assets/images/water_drop.png" alt="" />
          </span>
          <span>程序</span>
        </span>
        <!-- <span class="txt">{{ $t('live.code') }}：{{ deviceInfo.no }}</span> -->
      </div>

      <!-- RTU设备可以横向和卡片模式 -->
      <div class="card-icon">
        <van-icon
          @click="handleCamera(deviceInfo)"
          name="column"
          class="test2"
          v-if="deviceInfo.type === 2 || deviceInfo.type === 6"
        />
        <!-- 查看设备日志 所有设备都可查看 -->
        <van-icon @click="hadnleToGatewayLog(deviceInfo)" name="todo-list-o" />
      </div>

      <!-- 4 6 采集器和解码器设备 设备编号换一行 上面放轮灌组 -->
      <div
        class="deviceNo fs24"
        v-if="deviceInfo.type === 4 || deviceInfo.type === 6"
      >
        <span class="txt">{{ $t('live.code') }}：{{ deviceInfo.no }}</span>
      </div>
    </div>
    <div class="famen_list">
      <!-- <div
        class="device_item"
        v-for="(item, index) in deviceList"
        :key="item.groupName"
      >
        <div class="device_name orangeToYellow">
          <div>{{ item.groupName }}({{ item.no }})</div>
          <div style="display: flex;">
            <van-icon
              @click="handleCamera(item)"
              name="column"
              class="test2"
              v-if="item.type === 2 || item.type === 6"
              style="margin-right: 6px;"
            />

            <van-icon @click="hadnleToGatewayLog(item)" name="todo-list-o" />
          </div>
        </div>

      </div> -->

      <div class="famen_wrap">
        <div
          class="famen_item"
          v-for="(_item, _index) in portList"
          :key="_item.id"
        >
          <div class="fm_row fm_row1">
            <div class="fm_name">{{ _item.name }}</div>
            <div class="fm_xh"></div>
          </div>
          <div class="fm_row fm_row2">
            <div class="port">端口：{{ _item.portNo }}</div>
            <div class="task" v-show="_item.tasknum > 0">
              <font color="#f00">{{ _item.tasknum }}</font>
              {{ $t('first.task_num') }}
            </div>
            <div class="task" v-show="_item.tasknum == 0">
              {{ $t('first.notask') }}
            </div>
          </div>
          <div class="fm_row fm_row3">
            <div class="timer">{{ _item.timeStr }}</div>
            <div>
              <van-switch
                class="switch"
                v-model="_item.sw"
                @change="handleSwitch($event, _item, _index)"
                active-value="1"
                inactive-value="0"
                active-color="#1989fa"
                inactive-color="#ccc"
                size="24"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <customFooter :ison="2" />
    </div>
    <pageToast ref="pageToast" />
  </div>
</template>

<script>
import Top from './components/top.vue'
let timerDeviceStateTimer = null

export default {
  components: { Top },

  data() {
    return {
      valist: [],
      isLoading: false,
      deviceList: [],
      portList: [],
      deviceInfo: {},
      online: null,
    }
  },

  async created() {
    this.$toast.loading({
      message: this.$t('valva.val_loading'),
      forbidClick: true,
      duration: 0,
    })
    await this.getDeviceList()
    await this.getAllFamenList()
    await this.getDeviceOnline(this.deviceInfo.no)
    this.$toast.clear()
  },

  methods: {
    // 查询所有设备
    async getDeviceList() {
      await this.$api.getDeviceList().then((res) => {
        const list = res.data || []
        this.deviceList = [...list]
      })
    },

    // 获取所有阀门
    async getAllFamenList() {
      await this.$api.getAllValaveList().then((res) => {
        if (!this.$isblank(res.list)) {
          res.list.sort((a, b) => a.gatewayNo - b.gatewayNo)

          res.list.map(async (item, index) => {
            const nowDate = new Date(res.timestamp).getTime()
            let timeStep = ''
            item.sw = item.switchStt.toString()
            item.tasklist = ''
            item.timeStr = '00:00:00'
            if (item.lastUpdate && item.switchStt === 1) {
              // 将 - 替换成 / 兼容 iphone
              timeStep =
                nowDate -
                new Date(`${item.lastUpdate}`.replace(/-/g, '/')).getTime()

              timeStep = Math.ceil(timeStep / 1000)
              // 计算出 时 分 秒
              item.timeStr = this.$calculationTime(timeStep)
              item.timer = setInterval(() => {
                timeStep++
                item.timeStr = this.$calculationTime(timeStep)
              }, 1000)
            }
            // 获取任务列表
            item.tasknum = await this.getValvaTaskList(item.id)
            this.$refs.pageToast.type = 0
          })

          const portList = [...res.list]
          console.log('portList: ', portList)
          this.portList = [...portList]

          const tar = this.deviceList.find(
            (o) => o.no === portList[0].gatewayNo,
          )
          if (tar) {
            this.deviceInfo = { ...tar }
          }

          console.log('deviceInfo:', this.deviceInfo)
        } else {
          this.$refs.pageToast.type = 1
        }
      })
    },

    // 读取任务列表
    async getValvaTaskList(id) {
      return await this.$api
        .getValvaTaskList({
          valveId: id,
        })
        .then((res) => {
          if (res.errcode === 0 && res.data && res.data.length) {
            const list = res.data ? [res.data] : []
            return list.length
          } else {
            return 0
          }
        })
    },

    // 查看设备的在线情况
    async getDeviceOnline(no) {
      if (this.deviceInfo.type === 2 || this.deviceInfo.type === 7) return false
      clearInterval(timerDeviceStateTimer)
      await this.$api.getDeviceOnlineState({ no }).then((res) => {
        if (res.errcode === 0) {
          this.online = res.state === 'online' ? true : false
        } else {
          this.$toast(res.errmsg)
        }
      })

      // 3秒 轮训一次设备状态接口
      timerDeviceStateTimer = setInterval(() => {
        this.getDeviceOnline(this.deviceInfo.no)
      }, 1000 * 3)
    },

    // 设置
    handleSetting(item) {
      sessionStorage.setItem('liveSettingData', JSON.stringify(item))
      this.$router.push({
        path: '/liveSetting',
        query: { type: 'fm' },
      })
    },

    // 阀门开闭
    async handleSwitch(value, item, index) {
      try {
        let id = item.id
        //  1 开 0 关
        this.$toast.loading({
          message: this.$t('valva.val_loading'),
          forbidClick: true,
          duration: 0,
        })

        if (this.$isblank(id)) {
          this.$toast(this.$t('valva.val_chose'))
          return false
        }

        if (Number(value) === 1) {
          item.sw = '0'
          // 先不变开关状态  等接口反馈后在改变
          // 打开
          var ch = true
          var cn = this.$t('valva.val_open')
        } else {
          // 关闭
          item.sw = '1'
          var ch = false
          var cn = this.$t('valva.val_close')
        }

        const _this = this

        await this.$api
          .setValaveDetail({
            gatewayNo: item.gatewayNo,
            id,
            switchStt: ch,
          })
          .then((res) => {
            _this.$toast.clear()
            if (res.errcode === 0) {
              // 成功
              _this.$toast.success(
                _this.$t('trend.trend_valve') +
                  cn +
                  _this.$t('valva.val_success'),
              )

              const data = _this.portList[index]
              // true 是关闭阀门的时候
              if (ch) {
                item.sw = '1'
                let t = 0
                // 清空定时器
                clearInterval(data.timer)
                // 重新开启定时器
                data.timer = setInterval(() => {
                  t++
                  data.timeStr = _this.$calculationTime(t)
                }, 1000)
              } else {
                item.sw = '0'
                // 成功后 需要停止掉计时器
                data.timeStr = '00:00:00'
                clearInterval(data.timer)
              }
            } else {
              _this.$toast(res.errmsg)
              return false
            }
          })
          .catch((err) => {
            console.error(err)
          })
      } catch (err) {
        console.error('err:', err)
      }
    },

    // 照相机
    handleCamera(data) {
      localStorage.setItem('no', data.no)
      localStorage.setItem('dname', data.deviceName)
      this.$router.push(`/camera?type=${data.type}`)
    },

    // 去阀门登录日志页面
    hadnleToGatewayLog(data) {
      localStorage.setItem('no', data.no)
      localStorage.setItem('dname', data.deviceName)
      this.$router.push('/gatewayLog')
    },

    // 轮灌
    handleLunguan() {
      sessionStorage.setItem('deviceType', this.deviceInfo.type)
      this.$router.push('/lunguan')
    },
  },
}
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  background: #f7f7f7 !important;

  .litops {
    width: 100%;
    min-height: 60px;
    overflow: hidden;
    z-index: 2;
    padding: 10px;
    box-sizing: border-box;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
  }
}

.fm_name {
  font-size: 14px;
}

.port,
.task {
  font-size: 12px;
}

.device_item {
  width: 100%;

  .device_name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    padding: 10px 16px;
    color: #ffffff;
  }
}

.famen_wrap {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.famen_list {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  padding: 16px;
  box-sizing: border-box;
  padding-bottom: 60px;

  .famen_item {
    width: 49%;
    // height: 2.1rem;
    box-shadow: 0 0 0.1rem rgba(0, 0, 0, 0.05);
    border-radius: 0.1rem;
    background: #ffffff;
    margin-bottom: 0.2rem;
    padding: 0.1rem 0.2rem;
    box-sizing: border-box;

    &:nth-child(2n) {
      margin-right: 0 !important;
    }

    .fm_row {
      display: flex;
      height: 34px;
      line-height: 34px;
    }
    .fm_row1 {
      display: flex;
      justify-content: space-between;

      .fm_xh {
        .icon-wifi,
        .icon-dc {
          margin-right: 8px;
        }

        .icon-wifi {
          color: green;
        }

        .icon-dc {
          color: red;
          font-size: 20px;
          vertical-align: bottom;
        }

        img {
          width: 14px;
          height: 14px;
          vertical-align: baseline;
        }
      }
    }

    .fm_row2 {
      display: flex;
      justify-content: space-between;
    }

    .fm_row3 {
      display: flex;
      justify-content: space-between;
      width: 100%;

      .switch {
        font-size: 20px !important;
        vertical-align: middle;
      }
    }
  }

  .timer {
    font-size: 14px;
  }
}

.footer {
  position: fixed;
  bottom: 0;
  width: 100%;
}

.litops {
  width: 100%;
  overflow: hidden;
  z-index: 2;
  padding: 10px;
  box-sizing: border-box;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

.litop1,
.litop2 {
  display: inline-block !important;
}

.display-flex {
  .litop1 {
    display: flex;
    width: 100%;
  }

  .litop2 {
    // display: block !important;
  }
}

.litop1 {
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  color: #ffffff;
  line-height: 30px;
  width: 45%;
  height: 30px;
  margin-right: 10px;
}

.litop1 .litop1_left {
  display: flex;
  justify-content: space-between;
  position: relative;
  max-width: 200px;
  font-size: 18px;
  font-weight: 700;
}

.litop1 .litop1_left i {
  opacity: 0.5;
  position: relative;
  left: -2px;
}

.litop1 .litop1_left i.icon-xiala {
  font-size: 14px;
  padding: 0 5px;
}

.litop1 .litop1_left i.icon-lixian {
  font-size: 20px;
  color: black;
}

.litop1 .litop1_right {
  float: right;
  font-size: 12px;
  opacity: 0.4;
}

.litop1 .litop1_right img {
  width: 18px;
  height: 18px;
  margin-left: 0.15rem;
}

.online {
  font-size: 13px;
  color: #08ec08;
}

.offline {
  font-size: 13px;
  color: red;
}

.deviceName {
  // max-width: 100px;
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  font-size: 14px;
}

.litop2 {
  text-align: left;
  color: #c5d3f4;
  font-weight: bold;
  overflow: hidden;
  line-height: 30px;
}

.litop2 span img {
  width: 0.25rem;
  height: 0.19rem;
  vertical-align: middle;
  margin-top: -0.08rem;
}

.litop2 .txt6 {
  display: inline-block;
  height: 0.6rem;
  line-height: 0.6rem;
  background: #2b5dd8;
  border-radius: 0.1rem;
  padding-right: 0;
  padding: 0 8px;
  text-align: center;
  float: right;
  margin: 0rem 0rem 0 0;
  color: #ffffff;
}

.litop2 .txt6 a {
  color: #ffffff;
}

.litop2 .txt6 {
  background: #05a405;
}
.txt {
  font-size: 14px;
  font-weight: normal;
  margin-right: 10px;
}

.txt:last-child {
  margin-right: 0;
}

.card-icon {
  display: flex;
  justify-content: space-between;
  float: right;
  color: #ffffff;
  margin-top: 4px;

  /deep/ .van-icon {
    font-size: 20px;
  }
}

.test2 {
  margin: 0 10px;
}

.lunguan {
  // float: right;
  // display: flex;
  align-items: center;
  color: #ffffff;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  border: 1px solid #ffffff;
  border-radius: 16px;
  padding: 0 6px;

  img {
    width: 9px !important;
    height: 12px !important;
    margin-right: 4px;
  }
}

.deviceNo {
  color: #ffffff;
}
</style>
